import React, { useState } from 'react';
import { Plus, UserPlus, CalendarPlus, Wallet, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const OmniActionFab = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed right-6 bottom-24 lg:bottom-10 z-50">
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild>
          <button 
            className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:bg-primary/90 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-primary/30"
            aria-label="Acciones Rápidas"
          >
            <div className={`transition-transform duration-300 flex items-center justify-center ${isOpen ? 'rotate-90' : 'rotate-0'}`}>
              {isOpen ? <X className="h-6 w-6" /> : <Plus className="h-7 w-7" />}
            </div>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="end" 
          sideOffset={15}
          className="w-56 p-2 rounded-xl shadow-xl border-border/50 bg-background/95 backdrop-blur-sm"
        >
          <div className="px-2 py-2 text-xs font-bold text-muted-foreground uppercase tracking-widest">
            Creación Rápida
          </div>
          
          <DropdownMenuItem 
            className="flex items-center gap-3 p-3 cursor-pointer rounded-lg hover:bg-purple-500/10 focus:bg-purple-500/10 hover:text-purple-600 focus:text-purple-600 transition-colors"
            onClick={() => navigate('/events/new')}
          >
            <div className="bg-purple-500/10 p-2 rounded-md text-purple-600">
              <CalendarPlus className="h-4 w-4" />
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-sm">Nuevo Evento</span>
              <span className="text-[10px] text-muted-foreground leading-none mt-1">Crear cotización o contrato</span>
            </div>
          </DropdownMenuItem>

          <DropdownMenuItem 
            className="flex items-center gap-3 p-3 cursor-pointer rounded-lg hover:bg-emerald-500/10 focus:bg-emerald-500/10 hover:text-emerald-600 focus:text-emerald-600 transition-colors mt-1"
            onClick={() => navigate('/customers/new')}
          >
            <div className="bg-emerald-500/10 p-2 rounded-md text-emerald-600">
              <UserPlus className="h-4 w-4" />
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-sm">Nuevo Cliente</span>
              <span className="text-[10px] text-muted-foreground leading-none mt-1">Añadir persona o empresa</span>
            </div>
          </DropdownMenuItem>

          <DropdownMenuItem 
            className="flex items-center gap-3 p-3 cursor-pointer rounded-lg hover:bg-blue-500/10 focus:bg-blue-500/10 hover:text-blue-600 focus:text-blue-600 transition-colors mt-1"
            onClick={() => navigate('/payments/new')}
          >
            <div className="bg-blue-500/10 p-2 rounded-md text-blue-600">
              <Wallet className="h-4 w-4" />
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-sm">Registrar Pago</span>
              <span className="text-[10px] text-muted-foreground leading-none mt-1">Abono o liquidación</span>
            </div>
          </DropdownMenuItem>
          
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default OmniActionFab;
